import { makeStyles } from '@mui/styles'
import theme from '../../../theme'

export const useStyles = makeStyles( () => ( {
	// Matches TechStack's footer-nav technique/values so the bottom nav
	// lines up with the 185px rail shared by these section pages.
	footerNav: {
		[theme.breakpoints.up( 'laptop' )]: {
			marginLeft: '184px',
		},
	},
} ) )
